import { makeStyles, webLightTheme } from "@fluentui/react-components";

export const useNotFoundStyles = makeStyles({
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    marginTop: '40px'
  },
});

